import useCartTotals from './useCartTotals';

export default useCartTotals;
